module.exports = __webpack_public_path__ + "media/images/sprite-2c9d431f1a4667ece29ed061b1723747.png";